import PropTypes from "prop-types";
import React from "react";

import {isDesktop} from "utils";
import {Route} from "v2/api/Records";
import {canReorderDestinations} from "v2/api/Routes";
import ModalLink from "v2/components/responsive/ModalLink";
import ReorderDestinationsForm from "v2/components/responsive/ReorderDestinationsForm";

const ReorderDestinationsLink = (props, context) => {
  const {location: {pathname, query}} = context;
  const {data} = props;

  if (!isDesktop() || !canReorderDestinations(data)) {
    return null;
  }

  return (
    <ModalLink
      form={ReorderDestinationsForm}
      label="Reorder Destinations"
      showModal={query.modal === "reorder-destinations"}
      url={`${pathname}?modal=reorder-destinations`}
      {...props} />
  );
};

ReorderDestinationsLink.contextTypes = {
  location: PropTypes.object,
};
ReorderDestinationsLink.propTypes = {
  data: PropTypes.instanceOf(Route),
};

export default ReorderDestinationsLink;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/responsive/ReorderDestinationsLink.js
 **/